
<a *ngIf = "link"  href="{{qs.navigateQstn(qs.chapter,q)}}"
class="btn btn-primary border-0 badge "
style="margin-left: 10px">#{{qs.formatSeq(q.sequence,q.subSeq,q.part)}}</a>

<span *ngIf = "!link" class="btn btn-outline-primary border-0 badge "
style="margin-left: 10px"> #{{qs.formatSeq(q.sequence,q.subSeq,q.part)}} </span>

<span *ngIf='q.marks' class="float-right"> [{{q.marks}}] </span>
